import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { MoodBad } from '@mui/icons-material'
import { keyframes } from '@mui/system'

interface Props {
  message?: string
  icon?: React.ReactNode
}

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const NoDataMessageComponent: React.FC<Props> = React.memo(({ message, icon }): JSX.Element => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" p={2}>
      <Box
        sx={{
          px: { xs: 3, sm: 6 },
          py: { xs: 4, sm: 6 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 420,
          width: '100%',
          animation: `${fadeInUp} 0.7s cubic-bezier(0.4,0,0.2,1)`
        }}
      >
        {icon ?? <MoodBad color="primary" sx={{ fontSize: { xs: 64, sm: 88 }, mb: 2, opacity: 0.85, transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1)' }} />}
        <Box sx={{ textAlign: 'center', mb: 2 }}/>
        <Typography
          variant="h6"
          color="text.primary"
          align="center"
          sx={{ fontWeight: 500, mb: 1 }}
        >
          {message ?? 'There is no data available at this time...'}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
        >
        </Typography>
      </Box>
    </Box>
  )
})

NoDataMessageComponent.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired
}

NoDataMessageComponent.displayName = 'AppNoData'
export default NoDataMessageComponent
